import types from "../index";


export const defaultState = {
    selectedAddons: [],
    selectedSubscription: null,
    amount: 0,
}

function purchaseReducer(state, action) {
    switch (action.type) {
        case types.PURCHASE_SET_ADDONS: {
            return {
                ...state,
                selectedAddons: action.addons,
            }
        }
        case types.PURCHASE_SET_SUBSCRIPTION: {
            return {
                ...state,
                selectedSubscription: action.subscription,
            }
        }
        case types.PURCHASE_SET_AMOUNT: {
            return {
                ...state,
                amount: action.amount,
            }
        }
        case types.PURCHASE_ADD_ADDON: {
            const _addons = [...state.selectedAddons];
            if(!_addons.some(addon => addon.id === action.addon.id)) {
                _addons.push(action.addon);
            }

            return {
                ...state,
                selectedAddons: [..._addons]
            }
        }
        case types.PURCHASE_REMOVE_ADDON: {
            const _addons = state.selectedAddons.filter(addon => addon.id !== action.addon.id);
            return {
                ...state,
                selectedAddons: [..._addons],
            }
        }
        default:
            throw new Error("Unhandled action type: " + action.type);
    }
}

export default purchaseReducer;